import { render, staticRenderFns } from "./WalletOfSettingReport.vue?vue&type=template&id=0dc9b9d5"
import script from "./WalletOfSettingReport.vue?vue&type=script&lang=js"
export * from "./WalletOfSettingReport.vue?vue&type=script&lang=js"
import style0 from "./WalletOfSettingReport.vue?vue&type=style&index=0&id=0dc9b9d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports